import React, { useContext } from 'react';
import { Edit20Regular } from '@fluentui/react-icons';
import {
  Button,
  makeStyles,
  tokens,
  mergeClasses,
} from '@fluentui/react-components';
import { Spinner } from '@fluentui/react-spinner';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useBulkLocationsSearchContext } from './bulk-locations-search-provider';
import CountrySelect from './country-select';
import EnterBulkLocationsTextarea from './enter-bulk-locations-textarea';

const useStyles = makeStyles({
  container: {
    marginBottom: tokens.spacingVerticalL,
  },
  buttonsContainer: {
    marginTop: tokens.spacingVerticalXXL,
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
  },
  spinner: {
    marginRight: tokens.spacingHorizontalSNudge,
  },
  enterLocationsButton: {
    marginBottom: tokens.spacingVerticalSNudge,
  },
});

const EnterBulkLocations = () => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();
  const {
    isLoading,
    handleEnterLocationsClose,
    handleBulkSearch,
    isEnterLocationsOpen,
    setIsEnterLocationsOpen,
    setError,
    setInputText,
    inputText,
    error,
  } = useBulkLocationsSearchContext();

  return isEnterLocationsOpen ? (
    <div className={classes.container}>
      <CountrySelect />
      <EnterBulkLocationsTextarea error={error} setError={setError} inputText={inputText} setInputText={setInputText} />
      <div className={classes.buttonsContainer}>
        <Button appearance="secondary" disabled={error.length > 0 || isLoading} onClick={handleBulkSearch} className="match-locations-button">
          {isLoading && <Spinner className={classes.spinner} size="extra-tiny" />}
          {i18n.getString(isLoading ? _TL_('Finding locations...') : _TL_('Find locations'))}
        </Button>
        <Button appearance="transparent" onClick={() => handleEnterLocationsClose()}>{i18n.getString(_TL_('Cancel'))}</Button>
      </div>
    </div>
  ) :
    <Button className={mergeClasses(classes.enterLocationsButton, 'enter-locations-button')} appearance="transparent" onClick={() => setIsEnterLocationsOpen(true)} icon={<Edit20Regular />}>
      {i18n.getString(_TL_('Enter locations'))}
    </Button>;
};

export default EnterBulkLocations;
